<template>
  <div>
    <div class="tm-sidebar-left scroller uk-dark uk-animation-slide-left-small uk-animation-fast">     
        <a class="back-button uk-link-text" v-on:click="$emit('sidebarClick', '')"><i class="material-icons">arrow_back</i></a>           
        <div class="uk-text-bold header">
            <span>Banner</span>
        </div> 

        <form>
            <fieldset class="uk-fieldset">
                <p class="uk-margin-top"><i>Coming Soon...</i></p>
            </fieldset>
        </form>         
    </div>

  </div>

</template>

<script>
    import { Compact } from 'vue-color'
    
    export default {
        name: 'sidebar-design',
        components: {

            'compact-picker': Compact
        },
        data() {
            return {                               
            }
        },
    }
</script>

<style scoped>
    .header {
        border-bottom: 2px solid #1FB58F;
        margin-bottom: 10px;
        margin-top: 50px;  
        text-align: left;
        font-size: 18px;
    }

    .vc-compact {
        width: 180px !important;
    }

    .padding-small {
        padding: 12px;
    }

    .back-button {
        position: absolute;
        top: 10px;
        left: 10px;
    }

    .border-type {
        background: rgba(224, 224, 224, 0.6);
        border-bottom: 2px solid transparent;
    }

    .border-type:hover {
        background: rgba(224, 224, 224, 0.9);
        border-bottom: 2px solid #EAB126;
    }

    .file-type-active {
        transition: background-color 0.4s ease;
        background-color: rgb(219, 219, 219);
        pointer-events: none;
    }

    .uk-button-white:hover {
        background: white;
        box-shadow: 0 0 0 1px rgba(50,50,93,.1), 0 2px 5px 0 rgba(50,50,93,.1), 0 3px 9px 0 rgba(50,50,93,.08), 0 1px 1.5px 0 rgba(0,0,0,.08), 0 1px 2px 0 rgba(0,0,0,.08); 
    }

    .uk-card-active {
        outline: 2px solid #28a5f5;
    }

    .uk-placeholder {
        border: none;
    }

    .uk-panel .uk-padding-small {
        padding: 8px 10px 8px 10px;
    }

    a {
        text-decoration: none;
    }
</style>